import { AriaPopover, Heading } from "@sveabank/cc-common";

type Props = {
	heading: string;
	subHeading?: string;
};

const HeadingMobileLayout = ({ heading, subHeading }: Props) => (
	<section className="tablet:hidden flex items-center gap-4 p-4">
		<Heading.H1>{heading}</Heading.H1>
		{!!subHeading && <AriaPopover variant="info" content={() => subHeading} />}
	</section>
);

export default HeadingMobileLayout;
